import { Fade, makeStyles } from "@material-ui/core";
import React from "react";

type CustomPopoverProps = {
  open: boolean,
  title: string,
};

const useStyles = makeStyles({
  root: {
    position: "absolute",
    bottom: -30,
    right: "5%",
    backgroundColor: "#FFF",
    padding: 4,
    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)",
    borderRadius: "5px",
    zIndex: 999,
  },
});

const CustomPopover = ({ open, title }: CustomPopoverProps) => {
  const classes = useStyles();
  return (
    <Fade in={open}>
      <div className={classes.root}>{title}</div>
    </Fade>
  );
};

export default CustomPopover;
